module.exports = __webpack_public_path__ + "img/techmoran.1512d29e.png";